export default "__VITE_ASSET__D9M$qifq__"